import React, { useEffect, useState } from 'react';
import { LineGraph } from '@gerdau/hefesto-mais-web';
import {
  Column,
  DataProps
} from '@gerdau/hefesto-mais-web/_shared/graph/graph.types';
import moment from 'moment';
import { IBilledByMonthState } from '../../../../../store/ducks/dashboard/types';
import { uppercaseOnlyFirstLetter } from '../../../../../utils/formatStrings';

interface IBilledByMonthChartProps {
  billedByMonthState: IBilledByMonthState;
  isEmpty: boolean;
}

const BilledByMonthChart: React.FC<IBilledByMonthChartProps> = ({
  billedByMonthState
}) => {
  const PADDING_GRAPH = 15;
  const columns: Column[] = [
    {
      colors: {
        tone: '500',
        variant: 'primary-02'
      },
      dataKey: 'total',
      dataKeyTitle: 'Total'
    }
  ];

  const [dataSource, setDataSource] = useState<DataProps[]>([
    { date: '' },
    {
      total: 0,
      date: moment()
        .month(moment().month())
        .subtract(1, 'month')
        .format('MM/YY'),
      customizedTickValue: `${0}t`
    },
    {
      total: 0,
      date: moment().format('MM/YY'),
      customizedTickValue: `${0}t`
    },
    {
      total: 0,
      date: moment()
        .month(moment().month())
        .subtract(-1, 'month')
        .format('MM/YY'),
      customizedTickValue: `${0}t`
    },
    { date: '' }
  ]);

  const months: { [key: string]: number } = {
    jan: 0,
    fev: 1,
    mar: 2,
    abr: 3,
    mai: 4,
    jun: 5,
    jul: 6,
    ago: 7,
    set: 8,
    out: 9,
    nov: 10,
    dez: 11
  };

  const setDataSourceWithData = () => {
    if (billedByMonthState.data.length > 0) {
      const data: DataProps[] = billedByMonthState.data.map((data) => {
        return {
          date: `${moment(data.date, 'MMM/YYYY').format('MM/YY')}`,
          total: data.total as number,
          customizedTickValue: `${data.total}t`
        };
      });
      setDataSource([{ date: '' }, ...data, { date: '' }]);

      if (billedByMonthState.data.length === 1) {
        const [month, year] = billedByMonthState.data[0].date.split('/');

        const now = moment();
        now.month(months[month]);
        now.year(Number(year));

        const previousMonth = now
          .month(now.month())
          .subtract(1, 'month')
          .format('MM/YY');

        const nextMonth = now
          .month(now.month())
          .subtract(-2, 'month')
          .format('MM/YY');

        let newChartData: DataProps[] = [
          {
            date: `${uppercaseOnlyFirstLetter(previousMonth)}`,
            total: 0,
            customizedTickValue: `${0}t`
          },
          {
            date: `${moment(billedByMonthState.data[0].date, 'MMM/YYYY').format(
              'MM/YY'
            )}`,
            total: billedByMonthState.data[0].total as number,
            customizedTickValue: `${
              billedByMonthState.data[0].total as number
            }t`
          },
          {
            date: `${uppercaseOnlyFirstLetter(nextMonth)}`,
            total: 0,
            customizedTickValue: `${0}t`
          }
        ];

        newChartData = [{ date: '' }, ...newChartData, { date: '' }];
        setDataSource(newChartData);
      }
    }
  };

  useEffect(() => {
    setDataSourceWithData();
  }, [billedByMonthState.data]);

  return (
    <LineGraph
      columns={columns}
      XAxisCustomizedTick
      XAxisCustomizedTickLabel="Total"
      XAxisPadding={{ left: PADDING_GRAPH, right: PADDING_GRAPH }}
      dataSource={dataSource}
      lineDataKey="date"
    />
  );
};

export default BilledByMonthChart;
